/**
 * @see https://umijs.org/docs/max/access#access
 * */
import { getRoleNameList } from '@/services/models/auth';

export default function access(
  initialState: { currentUser?: AuthModel.UserProfile } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const roleNameList = getRoleNameList(currentUser);
  const isAdmin = roleNameList.includes('ADMIN');
  const canManageCase = isAdmin || roleNameList.includes('CASE_MANAGER');
  const canViewTask =
    isAdmin ||
    roleNameList.includes('CASE_MANAGER') ||
    roleNameList.includes('OPERATOR');

  const rolePermissionMap: Partial<Record<string, AuthModel.RoleName[]>> = {
    'institution:create': ['ADMIN'],
    'institution:edit': ['ADMIN'],
    'institution:delete': ['ADMIN'],
    'personnel:create': ['ADMIN'],
    'personnel:edit': ['ADMIN'],
    'personnel:delete': ['ADMIN'],
    'case:export': ['ADMIN', 'CASE_MANAGER'],
  };

  return {
    canAdmin: isAdmin,
    showMenu: () => Boolean(currentUser),
    canManageCase,
    canViewTask,
    showBtn: (code: string) => {
      if (!currentUser) {
        return false;
      }
      const requiredRoleNameList = rolePermissionMap[code];
      if (requiredRoleNameList) {
        return requiredRoleNameList.some((roleName) =>
          roleNameList.includes(roleName),
        );
      }
      if (isAdmin) {
        return true;
      }
      return false;
    },
  };
}
